class ProductRecommendations extends customElements.get('products-carousel') {
  constructor() {
    super();
  }

  connectedCallback() {
    this.carousel = this.querySelector('products-carousel');
    this.carousel.classList.add('hidden');

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('[data-container-products]');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.carousel.querySelector('[data-container-products]').innerHTML =
            recommendations.innerHTML;
          this.carousel.classList.remove('hidden');
          this.carousel.initSlider();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
